export default {
  name: "Tag",
  plural: "Tags",
};
